import { Operator } from "@skilitics/judy";

import type { ConditionBuilder, ConditionBuilderContext } from "../../../types";
import { createConditionBuildable } from "../../conditions";
import { LocaleConditionEditor } from "./LocaleConditionEditor";
import { LocaleConditionSummary } from "./LocaleConditionSummary";

interface Context extends ConditionBuilderContext {
  config: { locale?: string };
}

export const localeConditionBuilder: ConditionBuilder<Context> = {
  typeId: "locale" as const,
  defaultCategory: "Utility",
  build: ({ config: { locale }, envProperty }) => {
    if (!locale) return;

    return {
      type: "string",
      operator: Operator.EQ,
      subject: envProperty("locale", "string"),
      object: locale,
    };
  },
  isValid: ({ locale }) => !!locale,
  views: {
    summary: LocaleConditionSummary,
    edit: LocaleConditionEditor,
  },
};

/**
 * Retired in favour of the Value Comparison condition over the `locale` external
 * value, which says the same thing through the generic machinery now that locale
 * carries a subtype to supply the language list. Kept so existing conditions
 * still edit and publish; stored configs are left as they are.
 */
export const localeConditionBuildableCreate = () =>
  createConditionBuildable(
    localeConditionBuilder,
    localeConditionBuilder.typeId,
    { title: "Locale" },
    {},
    { retired: true },
  );
